import { WifiOff } from 'lucide-react';
import { SANS_CONTACT, ancienneteTexte } from '@/shared/utils/liveness';

/**
 * Machine injoignable — à ne JAMAIS confondre avec « pas encore confirmé ».
 *
 * « Pas encore confirmé » veut dire : la machine nous parle, elle n'a pas encore obéi,
 * laissons-lui le temps. « Injoignable » veut dire : elle ne nous parle plus, l'ordre part
 * dans le vide, et attendre n'y changera rien. Une seule de ces deux situations demande
 * d'appeler le client — les avoir mélangées est le défaut constaté le 28/07.
 *
 * Vit dans `shared` parce que les deux moments du pilotage en ont besoin : l'avertissement
 * avant l'envoi (`features/pilotage/components/PilotageConfirm`) et le verdict après
 * (`shared/components/PilotageResultDialog`). Un seul texte pour les deux, sinon ils
 * divergeront.
 *
 * @param {string}  etat  état de joignabilité ('deconnectee' | 'sans_contact')
 * @param {number}  ageS  ancienneté de la dernière mesure, en secondes
 * @param {boolean} avant true avant l'envoi (avertissement), false après (verdict)
 */
export default function UnreachableNotice({ etat, ageS, avant = false, children }) {
  const sansContact = etat === SANS_CONTACT;
  const age = ancienneteTexte(ageS);
  return (
    <div
      className="flex items-start gap-2 p-3 rounded-md bg-red-50 border border-red-100 text-[12px] text-red-800"
      data-testid={avant ? 'unreachable-warning' : 'result-unreachable'}
    >
      <WifiOff className="w-4 h-4 mt-0.5 flex-shrink-0 text-red-600" />
      <span>
        <strong>
          {sansContact
            ? 'Aucun contact enregistré pour cette batterie'
            : `Batterie injoignable${age ? ` depuis ${age}` : ''}`}
        </strong>
        {' : '}
        {avant
          ? "l'ordre sera enregistré et tracé, mais la batterie ne l'entendra pas tant "
            + "qu'elle ne redonne pas signe de vie."
          : "l'ordre a été enregistré et tracé, mais rien ne dit que la batterie l'a "
            + "reçu : elle n'envoie plus aucune mesure."}
        {' '}
        {sansContact
          ? 'À signaler à un administrateur.'
          : 'À vérifier auprès du client : machine éteinte, ou coupée.'}
        {children}
      </span>
    </div>
  );
}
